/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface ShareIconProps {
  size?: number
  color?: string
}

/**
 * SVG share/upload icon used in share triggers.
 * @param size - Icon dimensions in px (default 16)
 * @param color - Fill color (defaults to SOLITUDE from appColors)
 */
function ShareIcon({ size = 16, color = colors.SOLITUDE }: ShareIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 12 10'
      fill='none'
    >
      <path
        d='M7.33333 2.66667V0L12 4.66667L7.33333 9.33333V6.6C4 6.6 1.66667 7.66667 0 10C0.666666 6.66667 2.66667 3.33333 7.33333 2.66667Z'
        fill={color}
      />
    </svg>
  )
}

export default ShareIcon
